export const LOCALIZED_PT_IDENTIFIER_LOADED_SUCCESS = 'LOCALIZED_PT_IDENTIFIER_LOADED_SUCCESS';
